import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './CharacterPurchaseModal.module.css';
import dreamcoinLogo from "/dreamcoin-logo.svg";
export default function CharacterPurchaseModal({
  isOpen,
  isClosing,
  onClose,
  onConfirm,
  character
}) {
  const [dragPosition, setDragPosition] = useState({ y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const startPosition = useRef({ y: 0 });
  const [cardRotation, setCardRotation] = useState({ x: 0, y: 0 });
  const cardRef = useRef(null);
  
  if (!isOpen || !character) return null;

  const handleTouchMove = (e) => {
    e.stopPropagation();
    if (!cardRef.current) return;
    
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const y = e.touches[0].clientY - rect.top;
    
    // Расширяем область взаимодействия на 20px вокруг карточки
    const buffer = 0;
    if (
      x < -buffer || x > rect.width + buffer ||
      y < -buffer || y > rect.height + buffer
    ) {
      handleTouchEnd();
      return;
    }
    
    // Нормализуем координаты относительно реальных размеров карточки
    const normalizedX = Math.min(Math.max(x, 0), rect.width);
    const normalizedY = Math.min(Math.max(y, 0), rect.height);
    
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    
    const maxRotation = 15;
    
    const rotateY = ((normalizedX - centerX) / centerX) * maxRotation;
    const rotateX = ((centerY - normalizedY) / centerY) * maxRotation;
    
    const gradientAngle = Math.atan2(rotateX, rotateY) * (180 / Math.PI);
    
    setCardRotation({ x: rotateX, y: rotateY });
    
    if (cardRef.current) {
      cardRef.current.style.setProperty('--gradient-angle', `${gradientAngle}deg`);
    }
  };

  const handleTouchStart = (e) => {
    e.stopPropagation(); // Предотвращаем всплытие события
  };

  const handleTouchEnd = () => {
    setCardRotation({ x: 0, y: 0 });
    if (cardRef.current) {
      cardRef.current.style.setProperty('--gradient-angle', '0deg');
    }
  };

  const modalContent = (
    <div className={styles.modalWrapper}>
      <div className={`${styles.modal} ${isClosing ? styles.slideDown : ''}`}>
        <div className={styles.modalContent}>
          
          <div className={styles.imagePlaceholder}>
            <div 
              ref={cardRef}
              className={styles.characterIcon}
              style={{
                transform: `perspective(1000px) rotateX(${cardRotation.x}deg) rotateY(${cardRotation.y}deg)`,
                transition: cardRotation.x === 0 ? 'transform 0.5s ease-out' : 'none'
              }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <img 
                src={character.icon_url} 
                alt={character.title} 
                className={styles.characterImage}
                draggable="false"
              />
            </div>
          </div>
          <div className={styles.rewardsModal}>
            <p className={styles.rewardText}>
              Ты собираешься купить <br/> персонажа за
              <div className={styles.rewardsPrice}>
                {character.price}
                <img className={styles.dcReward} src={dreamcoinLogo} alt="dreamcoin" />
              </div>
            </p>
          </div>

          <button 
            className={styles.subscribeButton} 
            onClick={onConfirm}
          >
            Подтвердить покупку
          </button>
          <button 
            className={styles.cancelButton} 
            onClick={onClose}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(
    modalContent,
    document.body
  );
}
